import { Call } from '@domains';
import { Action, createReducer, on } from '@ngrx/store';

import * as fromActions from './call.actions';

export interface CallState {
  calls: Call[];
  callsTotalCount: number;
}

const initialState: CallState = {
  calls: [],
  callsTotalCount: 0,
};

const reducer = createReducer(
  initialState,

  on(fromActions.getCalls, (state) => ({
    ...state,
    callsTotalCount: 0,
    calls: [],
  })),
  on(fromActions.getCallsSuccess, (state, { results, resultsCount }) => ({
    ...state,
    calls: results,
    callsTotalCount: resultsCount,
  })),
);

export function callReducer(state: CallState | undefined, action: Action) {
  return reducer(state, action);
}
